import script from "./TheHeaderMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheHeaderMenu.vue?vue&type=script&setup=true&lang=ts"

import "./TheHeaderMenu.vue?vue&type=style&index=0&id=9aa728ec&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9aa728ec"]])

export default __exports__